// Onboarding Units
// Once these units are completed, then we should switch out of 'onboarding' mode
export const BEGIN_THE_REVOLUTION = 185;
export const CHANGE_YOUR_LIFE_IDS = [3311, 4131, 4132];
export const DESIRE_TYPE = 3451;

// Other hardcoded-course id values
export const FEELING_PRESENT_IN_YOUR_BODY = 223;
export const CORAL_BRANDING = 66;
export const YOUR_WEEKLY_PULSE = 285;
export const CREATING_SPACE_FOR_SEX = 64;